// extracted by mini-css-extract-plugin
export default {"toggleBox":"Toggle_toggleBox__RI-2d","toggle":"Toggle_toggle__ZNMXl","active":"Toggle_active__NCv0k"};